<i class="combo-box-icon cursor_pointer plus-minus">
  <span>+</span>
  <span class="minus">—</span>
</i>
